<template>
  <div class="e-layout" :class="{'is-mobile-menu-open': mobileMenuOpen}">
    <e-sidebar
      :state="menuState"
      :mobile-open="mobileMenuOpen"
      @changeState="changeState"
      @closeMobile="closeMobileMenu">
    </e-sidebar>

    <div class="e-container">
      <e-topbar
        :mobile-menu-open="mobileMenuOpen"
        @toggleMobileMenu="toggleMobileMenu">
      </e-topbar>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  name: "basicLayout",
  watch: {
    $route() {
      this.closeMobileMenu();
    }
  },
  methods: {
    changeState(state) {
      this.menuState = state;
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
    }
  },
  data() {
    return {
      menuState: 'open',
      mobileMenuOpen: false,
    };
  }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/layouts/basic.vue